import { defineMessages, type MessageDescriptor } from 'react-intl';

const messages: Record<
	| 'pinnedWorkHeading'
	| 'pinnedWorkAddButtonLabel'
	| 'pinnedWorkEmptyStateMessage'
	| 'pinnedWorkPinButtonLabel'
	| 'pinnedWorkLoadingLabel',
	MessageDescriptor
> = defineMessages({
	pinnedWorkLoadingLabel: {
		id: 'rovo-pins.pinned-work-section.pinnedWorkLoadingLabel',
		defaultMessage: 'Loading pinned work',
		description:
			'Accessible label for the loading skeleton shown while pinned work is being fetched',
	},
	pinnedWorkHeading: {
		id: 'rovo-pins.pinned-work.heading',
		defaultMessage: 'Pinned work',
		description: 'Heading for the pinned work section of the Rovo "For You" tab',
	},
	pinnedWorkAddButtonLabel: {
		id: 'rovo-pins.pinned-work.add-button-label',
		defaultMessage: 'Add pinned work',
		description:
			'Accessible label for the "+" button in the pinned work section header that navigates to search to pin work',
	},
	pinnedWorkEmptyStateMessage: {
		id: 'rovo-pins.pinned-work.empty-state-message',
		defaultMessage: 'Pin epics, projects, and goals here for one-tap chat access.',
		description:
			'Message shown in the pinned work section of the Rovo "For You" tab when no items are pinned',
	},
	pinnedWorkPinButtonLabel: {
		id: 'rovo-pins.pinned-work.pin-button-label',
		defaultMessage: 'Pin work',
		description:
			'Label for the button that navigates to the search view to pin work in the empty state of the pinned work section',
	},
});

export default messages;
